import { AutoComplete, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { automationReceivedRuleList } from "../../../../../../../services/ticketAutomationReceivedRule.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutomationReceivedRuleAllowedAction.";

export const ConsultationReceivedRule = () => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(automationReceivedRuleList);

  const [optionsConsultationReceivedRule, setConsultationReceivedRule] =
    useState<ISelectType[]>([]);

  const fetchConsultationReceivedRule = useCallback(async () => {
    const { data, success } = await sendRequest({ ticketAutomationCode: 20 });
    if (data && success) {
      setConsultationReceivedRule(
        data.map((d) => ({
          id: d.id,
          name: d.name,
        })),
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchConsultationReceivedRule();
  }, [fetchConsultationReceivedRule]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        fullWidth
        options={optionsConsultationReceivedRule}
        name="consultationTicketAutomationReceivedRule"
        label={t(translationPath + "consultation_received_rule")}
        getOptionLabel={(option) => option.name}
        size="small"
      />
    </Grid>
  );
};
